export const getWienData = () => ({
  name: "Wien",
  country: "Autriche",
  description: "Wien (Vienne) est une région viticole urbaine unique, réputée pour ses vins urbains de qualité. Cette région bénéficie d'un climat continental avec des influences urbaines, créant des conditions particulières pour la viticulture.",
  type: "region",
  area: "600 ha",
  production: "0.03 million hectolitres",
  climate: "Climat continental avec influences urbaines, étés chauds et hivers froids",
  soil: "Sols calcaires, argileux, alluviaux, diversité géologique",
  characteristics: {
    climate: "Climat continental avec influences urbaines, étés chauds et hivers froids",
    soil: "Sols calcaires, argileux, alluviaux, diversité géologique",
    viticulture: "Viticulture urbaine, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    white: "Vins blancs secs et aromatiques, avec une acidité vive",
    red: "Vins rouges légers et fruités, avec des tanins fins",
    rosé: "Rosés délicats et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture à Wien remonte à l'époque romaine. La ville a une tradition viticole unique avec des vignobles urbains. Aujourd'hui, Wien est reconnue pour ses vins urbains de qualité et son approche innovante.",
  foodPairing: "Cuisine viennoise traditionnelle, plats urbains, fromages affinés, cuisine internationale",
  subregions: {
    "Nussberg": {
      name: "Nussberg",
      description: "Colline viticole urbaine, spécialisée dans les vins blancs",
      area: "200 ha",
      characteristics: "Sols calcaires, climat urbain, vins blancs",
      grapeVarieties: ["gruner-veltliner", "riesling", "chardonnay", "sauvignon-blanc"]
    },
    "Bisamberg": {
      name: "Bisamberg",
      description: "Colline viticole produisant des vins rouges et blancs",
      area: "150 ha",
      characteristics: "Sols argileux, climat tempéré, vins équilibrés",
      grapeVarieties: ["zweigelt", "blaufrankisch", "gruner-veltliner", "riesling"]
    },
    "Mauer": {
      name: "Mauer",
      description: "Zone viticole urbaine avec des vignobles établis",
      area: "100 ha",
      characteristics: "Sols alluviaux, microclimats, vins aromatiques",
      grapeVarieties: ["gruner-veltliner", "riesling", "zweigelt", "pinot-noir"]
    }
  },
  grapeVarieties: [
    {
      name: "Grüner Veltliner",
      percentage: "45%",
      description: "Cépage emblématique d'Autriche, produisant des vins blancs secs et aromatiques",
      characteristics: "Sec, aromatique, acidité vive",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Riesling",
      percentage: "25%",
      description: "Cépage blanc produisant des vins secs et minéraux",
      characteristics: "Sec, minéral, acidité vive",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Zweigelt",
      percentage: "20%",
      description: "Cépage rouge principal, produisant des vins légers et fruités",
      characteristics: "Léger, fruité, tanins fins",
      wineStyles: "Sec, léger, fruité"
    },
    {
      name: "Chardonnay",
      percentage: "5%",
      description: "Cépage blanc produisant des vins secs et équilibrés",
      characteristics: "Sec, équilibré, notes de fruits blancs",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Autres",
      percentage: "5%",
      description: "Autres cépages incluant Blaufränkisch, Pinot Noir et cépages autochtones",
      characteristics: "Diversifiés, expérimentaux",
      wineStyles: "Variés selon le cépage"
    }
  ],
  mapAreas: [
    { region: "Nussberg", x: 16.4, y: 48.2, color: "#4B164C", size: 2 },
    { region: "Bisamberg", x: 16.5, y: 48.3, color: "#6d2c7a", size: 2 },
    { region: "Mauer", x: 16.3, y: 48.1, color: "#8a4a8a", size: 1 }
  ]
}); 